import React, { useState, useEffect } from "react";

function Footer() {
  const currentYear = new Date().getFullYear();
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer className="footer-single-color py-3 border-top">
        <div className="container">
          <div className="row align-items-center text-center text-md-start">

            {/* LEFT CONTENT */}
            <div className="col-md-8 mb-2 mb-md-0">
              <p className="mb-0 small">
                &copy; {currentYear}{" "}
                <a href="/" className="fw-semibold text-decoration-none text-primary">
                  energyindia
                </a>{" "}
                | All rights reserved |{" "}
                <a href="/privacy-policy" className="text-muted text-decoration-none">
                  Privacy Policy
                </a>{" "}
                |{" "}
                <a href="/terms-conditions" className="text-muted text-decoration-none counting">
                  Terms & Conditions
                </a>
              </p>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-md-4 text-md-end">
              <p className="mb-0 small text-muted">
                Designed by{" "}
                <a
      href="https://www.anekantprakashan.com"
      target="_blank"
      rel="noopener noreferrer"
      className="text-muted fw-semibold text-decoration-none"
    >
                  anekant prakashan
                </a>
              </p>
            </div>

          </div>
        </div>
      </footer>

      {showButton && (
        <button className="scroll-to-top-btn" onClick={scrollToTop}>
          ↑
        </button>
      )}
    </>
  );
}

export default Footer;
